import { render, staticRenderFns } from "./u-txt-dot.vue?vue&type=template&id=735e7bba&scoped=true"
import script from "./u-txt-dot.vue?vue&type=script&lang=js"
export * from "./u-txt-dot.vue?vue&type=script&lang=js"
import style0 from "./u-txt-dot.vue?vue&type=style&index=0&id=735e7bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e7bba",
  null
  
)

export default component.exports